/**
 * Created by RSchweber-Koren on 4/11/2017.
 */

import angular from "angular";

import Assert from "tbAssert";

import ElectionCandidateFactoryModule from "./ElectionCandidateFactory";

import Election from "../Election";
import ElectionType from "../ElectionType";
import Recipient from "../Recipient";

const mElectionCandidateFactorySvc = new WeakMap();

class ElectionFactory {
    constructor(ElectionCandidateFactory) {
        Assert.StrictAssert(ElectionCandidateFactory != null, "Assertion Failure: Missing or Invalid Election Candidate Factory Service Dependency");

        mElectionCandidateFactorySvc.set(this, ElectionCandidateFactory);
    }

    CopyElection(otherElection) {
        return new Election(
            otherElection.electionId,
            otherElection.electionType,
            new Date(otherElection.electionDate.getTime()),
            otherElection.electionOffice,
            otherElection.electionCandidates,
            otherElection.electionSubscribers
        );
    }

    FromServerElection(serverElection, clientElectionOfficeCb) {

        let electionDate = new Date(serverElection.ElectionDate);

        let electionOffice = undefined;

        if (angular.isDefined(serverElection.ElectionOffice)) {
            if (angular.isDefined(clientElectionOfficeCb)) {
                if ((clientElectionOfficeCb != null) && (serverElection.ElectionOffice != null)) {
                    electionOffice = clientElectionOfficeCb(serverElection.ElectionOffice);
                }
            }
        }

        let serverElectionCandidates = undefined;
        if (angular.isDefined(serverElection.Candidates)) {
            serverElectionCandidates = serverElection.Candidates.map(
                (serverCandidate) => mElectionCandidateFactorySvc.get(this).FromServerElectionCandidate(serverCandidate)
            );
        }

        let serverElectionType = ElectionType.FromServerElectionType(serverElection.ElectionType);

        let serverElectionSubscriberData = undefined;
        if ((angular.isDefined(serverElection.Subscribers)) &&
            (angular.isArray(serverElection.Subscribers)))
        {
            serverElectionSubscriberData = serverElection.Subscribers.map(function(eSub) {
                return Recipient.FromServerRecipient(eSub);
            });
        }

        return new Election(
            serverElection.ElectionId,
            serverElectionType,
            electionDate,
            electionOffice,
            serverElectionCandidates,
            serverElectionSubscriberData
        );
    }
}

ElectionFactory.$inject = [
    "ElectionCandidateFactory"
];

export default angular
    .module("trackerbase-app.models.factories.election-factory",[
        ElectionCandidateFactoryModule
    ])
    .service("ElectionFactory", ElectionFactory)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/models/factories/ElectionFactory.js
// module id = scp+
// module chunks = 1